// extracted by mini-css-extract-plugin
export default {"btnSubmittedDetails":"mgLRn__btnSubmittedDetails","btnPopOver":"e4kda__btnPopOver"};